import { useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export const handleUnauthorized = (navigate, showAlert) => {
  // Clear BOTH storages — SignInLayer writes the session to sessionStorage
  // too, and a surviving copy there bounces /sign-in straight back to
  // /dashboard (the 401 redirect loop that rate-limited the operator out).
  const sessionKeys = [
    "authToken",
    "name",
    "admin_id",
    "profile_picture",
    "user_role",
    "permissions",
  ];
  sessionKeys.forEach((key) => {
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
  });
  localStorage.removeItem("lastActivityTime");
  localStorage.removeItem("sessionHeartbeat");

  if (showAlert) {
    showAlert("Session expired. Please login again");
  }
  setTimeout(() => {
    navigate('/sign-in');
    showAlert('');
  }, 2000);
};

const INACTIVITY_TIMEOUT_MS = 60 * 60 * 1000; // 1 hour
// const INACTIVITY_TIMEOUT_MS = 1 * 60 * 1000; // 1 minute

const LAST_ACTIVITY_KEY = 'lastActivityTime';

const useInactivityLogout = (showAlert) => {
  const navigate = useNavigate();
  const logoutRef = useRef(false); // prevent multiple logouts

  const logoutUser = useCallback(() => {
    if (!logoutRef.current) {
      logoutRef.current = true;
      handleUnauthorized(navigate, showAlert);
    }
  }, [navigate, showAlert]);

  const checkAndUpdateActivity = useCallback(() => {
    const lastActivityStr = localStorage.getItem(LAST_ACTIVITY_KEY);
    const now = Date.now();

    if (!lastActivityStr) {
      logoutUser();
      return;
    }

    const lastActivity = parseInt(lastActivityStr, 10);
    if (isNaN(lastActivity) || now - lastActivity > INACTIVITY_TIMEOUT_MS) {
      logoutUser(); // expired
    }
    //  else {
    //   localStorage.setItem(LAST_ACTIVITY_KEY, now.toString()); // still valid, update time
    // }
  }, [logoutUser]);

  useEffect(() => {

    // ✅ FIX 1: Initialize timestamp ONCE if missing (prevents refresh logout)
    const existingActivity = localStorage.getItem(LAST_ACTIVITY_KEY);
    if (!existingActivity) {
      localStorage.setItem(LAST_ACTIVITY_KEY, Date.now().toString());
    }


    const navEntries = performance.getEntriesByType("navigation");
    const wasReloaded = navEntries.length > 0 && navEntries[0].type === "reload";

    // If reloaded, we still want to check timeout
    if (wasReloaded) {
      const lastActivityStr = localStorage.getItem(LAST_ACTIVITY_KEY);
      const now = Date.now();
      const lastActivity = parseInt(lastActivityStr, 10);

      if (!lastActivityStr || isNaN(lastActivity) || now - lastActivity > INACTIVITY_TIMEOUT_MS) {
        logoutUser();
        return;
      }
    }

    // Set initial timestamp
    // localStorage.setItem(LAST_ACTIVITY_KEY, Date.now().toString());

    const interval = setInterval(() => {
      checkAndUpdateActivity();
    }, 1000);

    const handleInteraction = () => {
      // checkAndUpdateActivity();
      localStorage.setItem(LAST_ACTIVITY_KEY, Date.now().toString());

    };

    window.addEventListener('mousemove', handleInteraction);
    window.addEventListener('keydown', handleInteraction);
    window.addEventListener('click', handleInteraction);
    window.addEventListener('scroll', handleInteraction);

    return () => {
      clearInterval(interval);
      window.removeEventListener('mousemove', handleInteraction);
      window.removeEventListener('keydown', handleInteraction);
      window.removeEventListener('click', handleInteraction);
      window.removeEventListener('scroll', handleInteraction);
    };
  }, [checkAndUpdateActivity, logoutUser]);

  return null;
};

export default useInactivityLogout;
